import { render, staticRenderFns } from "./OeText.vue?vue&type=template&id=726f00fa&scoped=true&"
import script from "./OeText.vue?vue&type=script&lang=js&"
export * from "./OeText.vue?vue&type=script&lang=js&"
import style0 from "./OeText.vue?vue&type=style&index=0&id=726f00fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f00fa",
  null
  
)

export default component.exports